import CONSTANTS from '../constants';
import CacheService from './cacheService';
import axios from 'axios';
import moment from 'moment';

export default {
    refreshAccessToken
}


// TODO Define it in generic service
async function refreshAccessToken() {
    if(shouldRefreshToken()) {
        let bname = CacheService.getToken().bname;
        let oldAccessToken = CacheService.getToken().token;
        let result = await axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.REFRESH_TOKEN}`, {
            headers: {
                'Business-Name': bname,
                'Access-Token': oldAccessToken
            }});
        CacheService.setToken(result.data.access_token, bname);
    }
    return CacheService.getToken().token;
}

function shouldRefreshToken() {
    return moment().unix() - CacheService.getTokenRefreshTime() > CONSTANTS.TOKEN_EXPIRY_SECONDS;
}


// WEBPACK FOOTER //
// ./src/services/appService.js